import { Box, Button, Grid, IconButton, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { WSPDashboardService } from '../../../../Api/WSPDashboard/WSPDashboardService';
import { WSPATRReportType } from '../../../../Model/Enum/BEE123Enums';
import { DashboardSectionType } from '../../../../Model/Enum/DashboardType';
import { PieChart } from '../Base/PieChart/PieChart';
import { CurrencyFormatter } from '../../../../../Helpers/CurrencyFormatter';
import { IPieChartDataSet } from '../Base/PieChart/IPieChartData';
import { useRecoilValue } from 'recoil';
import { WSPScorecardAtom } from '../../../../../State/WSPScorecard.Atom';
import { useHistory } from 'react-router-dom';
import { formControlColour, tooltipColour } from '../../BEE123.Constants';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { MerSETAReportService } from '../../../../Api/WSPReport/MerSETAReportService';
import moment from 'moment';
const hash = require("object-hash");

interface IProps {
    scorecardId?: string;
    scorecardTypeId?: string;
    chartOptions?: any;
    dashboardType?: DashboardSectionType;
    reportType: WSPATRReportType;
}

export const CostAndInterventionChart = (props: IProps) => {
    const WSPScorecard = useRecoilValue(WSPScorecardAtom);
    const history = useHistory();
    const reportUrl = `/wsp/scorecard/${WSPScorecard.wspScorecardId}/MerSETAReport`
    
    const hashObj = {}
    const hashString = hash(hashObj);
    const [display, setDisplay] = React.useState('cost');
    const [counter, setCounter] = React.useState(0);
    const [lastPopulatedDate, setLastPopulatedDate] = React.useState<Date | null>(null);

    useEffect(() => {
        getLastPopulatedDate();
    }, [])

    const getPieChartData = async () => {
        const labelArray: Array<string> = ['Grant-Type', 'Value'];

        const response = await WSPDashboardService.GetFundingChart(props.scorecardId!, props.reportType);

        let chartData: Array<IPieChartDataSet> = [];

        response.data.data.forEach(item => {
            const chartItem: IPieChartDataSet = {
                label: item.label,
                value: display === "cost" ? item.cost : item.headcount,
                sortOrder: item.sortOrder,
                backgroundColor: item.fundingCodeId === 1 ? '#4270c1' : '#e97c30',
            }
            chartData.push(chartItem);
        });

        const result = {
            isSuccess: true,
            errorMessage: '',
            value: {
                labels: labelArray,
                datasets: chartData,
                valueFormatter: display === "cost" ? CurrencyFormatter : undefined
            }
        }
        return result;
    }

    const getLastPopulatedDate = async () => {
        try {
            const lastPopulatedDate = await MerSETAReportService.getLastPopulateDate(props.scorecardId!, props.reportType);
            if (lastPopulatedDate.data){
                setLastPopulatedDate(lastPopulatedDate.data);
            }    
        } catch (error) {
            console.log(error)
        }    
    }

    const handleToggleChange = (
        event: React.MouseEvent<HTMLElement>,
        newDisplay: string,
    ) => {
        if (newDisplay != null) {
            setCounter(counter + 1);
            setDisplay(newDisplay);
        }
    };

    const handleRouting = () => {
        if (props.reportType === 1) {
            history.push(`${reportUrl}/ATRReport`);
        }
        else if (props.reportType === 2) {
            history.push(`${reportUrl}/WSPReport`);
        }
    };

    const formattedDate: string = moment(lastPopulatedDate).format('DD MMMM YYYY HH:mm');

    return (
        <>
            <Box sx={{ margin: 1 }}>
                <Grid container>
                    <Grid item xs={12} textAlign="right" margin={2} marginBottom={0}>
                        <ToggleButtonGroup
                            color="primary"
                            value={display}
                            exclusive
                            onChange={handleToggleChange}
                            aria-label="Platform"
                        >
                            <ToggleButton value="cost">Cost</ToggleButton>
                            <ToggleButton value="headcount">Headcount</ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>
                    <Grid item xs={12} marginTop={0}>
                        <PieChart
                            key={counter}
                            hash={hashString}
                            isPowerpointPrint={props.chartOptions.isPowerPointPrint !== undefined ? props.chartOptions.isPowerPointPrint : false}
                            fetchData={() => getPieChartData()}
                            hideLegend={false}
                            legendPositionRight={true}
                            pieSliceFormat="percentage"
                            reduceWhiteSpace={true}
                            emptyMessage={
                                <>
                                    It seems like your {WSPATRReportType[props.reportType]} report is empty.
                                    <br />
                                    Please take a moment to ensure that your {WSPATRReportType[props.reportType]} report is populated.
                                    <p />
                                    <Button variant='contained' onClick={handleRouting}>
                                        Go to {WSPATRReportType[props.reportType]} Report
                                    </Button>
                                </>         
                            }
                        />
                    </Grid>
                    {lastPopulatedDate && (
                    <Grid item xs={12} textAlign="left" marginTop={2}>
                        <Typography>
                            <span style={{ fontStyle: 'italic' }}>as at </span>
                            <span style={{ fontWeight: 'bold' }}>{formattedDate}</span>
                            <Tooltip
                                title={
                                    <React.Fragment>
                                        This chart is based on the {WSPATRReportType[props.reportType]} Report which was last populated at <strong>{formattedDate}</strong>.
                                    </React.Fragment>
                                }
                                arrow
                                placement="right"
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            bgcolor: tooltipColour,
                                            maxWidth: '250px',
                                            '& .MuiTooltip-arrow': {
                                                color: tooltipColour
                                            },
                                        },
                                    },
                                }}>
                                <IconButton
                                    size="small"
                                    edge="end"
                                    color="inherit"
                                    aria-label="info"
                                    style={{ marginTop: '-2px' }}
                                >
                                    <InfoOutlinedIcon style={{ color: formControlColour }} />
                                </IconButton >
                            </Tooltip>
                        </Typography>
                    </Grid>
                    )}
                </Grid>
            </Box>
        </>
    )
};


